export default "__VITE_ASSET__882286c9__"